module.exports = __webpack_public_path__ + "img/acrylic.a71ca7c2.png";